import { propEq } from 'ramda';
import { branch, compose, lifecycle, renderNothing, withState } from 'recompose';

const delayRender = (delay = 0) => compose(
  withState('isHidden', 'setIsHidden', true),
  lifecycle({
    componentWillMount() {
      setTimeout(() => this.props.setIsHidden(false), delay);
    },
  }),
  branch(
    propEq('isHidden', true),
    renderNothing,
  ),
);

export default delayRender;
